<template>
  <div class="freeEchart">
    <p>【{{freeTitle}}】</p>
    <div class="echart" ref="echart"></div>
    <div class="tool">
      <i @click="toggleFreeData('time')" class="iconfont icon-bar-chart" />
      <i @click="toggleFreeData('wrong')" class="iconfont icon-area-chart" />
      <i @click="toggleFreeData('score')" class="iconfont icon-pie-chart" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import * as echarts from 'echarts';
import report from '@/api/report';

export default {
  props: {
    classify: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      freeTitle: '最近一周内学习用时统计',
      freeData: {},
    };
  },
  methods: {
    renderFreeChart(data) {
      const chartDom = this.$refs.echart;
      const myChart = echarts.init(chartDom);

      let echartName, unit, values;
      if (this.freeTitle === '最近一周内学习用时统计') {
        echartName = '学习时间';
        unit = '分钟';
      } else if (this.freeTitle === '最近一周内错题数量统计') {
        echartName = '错题数量';
        unit = '道';
      } else {
        echartName = '试卷分数';
        unit = '分';
      }

      if (unit === '分钟') {
        values = Object.values(data).map(item => Math.ceil(item/60));
      } else {
        values = Object.values(data);
      }

      const option = {
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: Object.keys(data),
          axisLine: {
            lineStyle: {
              color: '#E9EFF3',
            }
          },
          axisLabel: {
            color: '#5A5FEF',
            margin: 30,
            fontSize: 16,
          },
          axisTick: {
            show: false,
          },
        },
        tooltip: {
          trigger: 'axis',
          formatter: `{b}<br/>{a0}:{c0}${unit}`,
        },
        toolbox: {
          show: true,
          left: '1%',
          itemSize: 35,
          itemGap: 25,
          iconStyle:{
            borderColor: '#5A5FEF',
            borderWidth: 2,
          },
          feature: {
            magicType: {
              type: ['line', 'bar'],
            },
            saveAsImage: {}
          },
        },
        legend: {
          data: [echartName],
          textStyle: {
            color: '#117CF7',
            fontSize: 26,
          },
          top: '6px',
          right: '0px',
          selectedMode: false,
        },
        grid: {
          top: '80px',
          left: '1%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          splitNumber: 4,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#5A5FEF',
            }
          },
          splitLine: {
            show: true,
            lineStyle:{
              color: '#E9EFF3',
              width: 1,
              type: 'solid'
            }
          },
          axisLabel: {
            color: '#5A5FEF',
            margin: 30,
            fontSize: 16,
          },
        },
        series: [{
          name: echartName,
          data: values,
          type: 'line',
          color: '#117CF7',
          showSymbol: false,
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#ADCBF8' },
                { offset: 1, color: '#F2F5F9' }
              ])
            }
          },
        }]
      };
      myChart.setOption(option, true);
      window.onresize = myChart.resize;
    },
    toggleFreeData(type) {
      if (type === 'time') {
        this.freeTitle = '最近一周内学习用时统计';
        this.getWeekLearnTime();
      } else if (type === 'wrong') {
        this.freeTitle = '最近一周内错题数量统计'
        this.getWeekWrong();
      } else {
        this.freeTitle = '最近7次试卷分数统计'
        this.getLatelySevenTest();
      }
    },
    // 自由组合一周内学习时间
    getWeekLearnTime() {
      report.getWeekLearnTime({
        subject_code: this.classify,
      }).then((data) => {
        this.freeData = data;
        this.renderFreeChart(data);
      })
    },
    // 自由组合一周内错题
    getWeekWrong() {
      report.getWeekWrong({
        subject_code: this.classify,
      }).then((data) => {
        this.freeData = data;
        this.renderFreeChart(data);
      });
    },
    // 自由组合近7次考试统计
    getLatelySevenTest() {
      this.freeData = {};
      report.getLatelySevenTest({
        subject_code: this.classify,
      }).then((data) => {
        data.forEach((item) => {
          this.freeData[item.updated] = item.accuracy;
        });
        this.renderFreeChart(this.freeData);
      })
    },
  },
  mounted() {
    this.getWeekLearnTime();
  },
  watch: {
    classify() {
      switch (this.freeTitle) {
        case '最近一周内学习用时统计': {
          this.getWeekLearnTime();
          break;
        }
        case '最近一周内错题数量统计': {
          this.getWeekWrong();
          break;
        }
        default: {
          this.getLatelySevenTest();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  .freeEchart {
    margin-top: 2%;
    padding: 2%;
    position: absolute !important;
    left: 7%;
    box-sizing: border-box;
    width: 86%;
    height: 71vh;
    p {
      margin: 0;
      font-size: 2.5vh;
      font-weight: bold;
      text-align: center;
    }
    .echart {
      height: 90%;
      width: 100%;
    }
    .tool {
      text-align: right;
      i {
        margin-left: 2%;
        cursor: pointer;
        color: #5A5FEF;
        font-size: 5vh;
      }
    }
  }
</style>
